$(document).ready(function(){
  // product variant section
  $(".product-variant-slider").slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // globally declared variable
  let bundleVariants = [];
  let quantity = 1
  let currentIndex = 0;
  let totalPrice = 0;
let dataCurrency = $("html").attr("data-currency")
                || $("body").attr("data-currency")
                || "$";
  const maxPrice = 1800;
  const milestones = [
    { threshold: 900, class: "milestone-one" },
    { threshold: 1300, class: "milestone-two" },
    { threshold: 1800, class: "milestone-three" },
  ];


 

  //*** START sticky bundle default item js
  function replaceDefaultItem(element) {
    const defaultItems = $(".sticky-bundle-product-add-wrapper .sticky-bundle-default-item").first();
    if (defaultItems.length) {
      const defaultItem = defaultItems.first();
      const closestWrapper = element.closest(".product-list-wrapper-with-content");
      const imageSrc = closestWrapper.find("img").attr("src");
      const productPrice = element.attr("data-product-price");
      const bdVariantID = element.attr("data-variantid");
      var productTitle = element.attr("data-product-title");
      defaultItem.find(".sticky-bundle-product-content-image img").attr("src", imageSrc);
      defaultItem.attr("data-variant-id", bdVariantID);
      defaultItem.find(".product-item-price").text(dataCurrency + productPrice);
      defaultItem.find(".sticky-item-close-icon").css("display", "flex");
      defaultItem.find(".quantity-add-remove").css("display", "flex");
      defaultItem.attr("data-title", productTitle);
      defaultItem.attr("data-price", productPrice);
      defaultItem.closest(".sticky-bundle-product-add-wrapper ul").find(".sticky-bundle-popup-wrapper .popup-open-wrapper").css({ "pointer-events": "inherit", opacity: "1" });
      defaultItem.removeClass("sticky-bundle-default-item");
    }
  }
  //*** END sticky bundle default item js

  // Update the sticky item with a new item START
  function addNewStickyItem(element, closestWrapper) {
    const bnVariantID = element.attr("data-variantid");
    const bnTitle = element.attr("data-product-title");
    const bnPrice = element.attr("data-product-price");
    $(".sticky-bundle-product-add-wrapper ul .sticky-bundle-popup-wrapper").before(`
      <li>
        <div class="sticky-bundle-product-content-wrapper" data-variant-id="${bnVariantID}" data-title="${bnTitle}" data-price="${bnPrice}">
          <span class="product-item-close sticky-item-close-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M7.42111 8.79347L4.64517 6.01752L1.88994 8.77275L0.72984 7.61265L3.48507 4.85742L0.72984 2.10219L1.90375 0.928284L4.65898 3.68351L7.41421 0.928284L8.57431 2.08838L5.81908 4.84361L8.59502 7.61956L7.42111 8.79347Z" fill="black"/></svg>
          </span>
          <span class="quantity-add-remove"></span>
          <div class="sticky-bundle-product-content-image"><img src="${closestWrapper.find("img").attr("src")}"></div>
          <span class="product-item-price">${dataCurrency + element.attr("data-product-price")}</span>
        </div>
      </li>
    `);
  }
  // Update the sticky item with a new item. END

  // *** Start Update the popup list with a new item.
  function updatePopupList(element, imageSrc, productPrice) {
    var updatePopupVariantId = element.attr("data-variantid");
    var updatePopupTitle = element.attr("data-product-title");
    var updatePopupPrice = element.attr("data-product-price");
    const popupItem = `
      <li class="popup-product-item" data-variant-id="${updatePopupVariantId}" data-title="${updatePopupTitle}" data-price="${updatePopupPrice}">
        <div class="popup-product-content-wrapper" >
          <span class="product-item-close bundle-popup-close-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M7.42111 8.79347L4.64517 6.01752L1.88994 8.77275L0.72984 7.61265L3.48507 4.85742L0.72984 2.10219L1.90375 0.928284L4.65898 3.68351L7.41421 0.928284L8.57431 2.08838L5.81908 4.84361L8.59502 7.61956L7.42111 8.79347Z" fill="black"/></svg>
          </span>
          <span class="quantity-add-remove"></span>
          <div class="popup-product-content-image"><img src="${imageSrc}"></div>
          <div class="popup-product-title-item" data-variant-id="${updatePopupVariantId}"><span class="popup-product-title-text">${updatePopupTitle}</span></div>
          <span class="popup-product-price">${dataCurrency + productPrice}</span>
        </div>
      </li>`;
    $(".sticky-bundle-popup-product-list ul").append(popupItem);
  }
  // **** END Update the popup list with a new item.

  // *** START Update the popup list with a new item title.
  function updatePopupProductTitleList(element, title) {
    var dataVariantId = element.attr("data-variantid");
    const titleItem = `<li class="popup-product-title-item" data-variant-id="${dataVariantId}"><span class="popup-product-title-text">${title}</span></li>`;
    $(".sticky-bundle-product-title-add ul").append(titleItem);
  }
  // **** END Update the popup list with a new item title.

  // *** START Add product item price function
  function addPrice(element, productPrice) {
    var numericPrice = parseFloat(productPrice.replace(/[^0-9.-]+/g, ""));
    totalPrice += numericPrice;
    $(".sticky-bundle-product-price").text(
      dataCurrency + totalPrice.toFixed(2)
    );
   updateUI();
  }
  // *** END Add product item price function

  // *** START Update Progress Bar
  function updateProgressBar() {
    const progressPercentage = Math.min((totalPrice / maxPrice) * 100, 100);
    $(".progress-bar").animate({ width: progressPercentage + "%" }, 500);
    $(".milestone").removeClass("active");
    milestones.forEach((milestone, index) => {
      if (totalPrice >= milestone.threshold) {
        $("." + milestone.class).addClass("active");
        $(".progress-bar-wrapper--content").find(".progress-bar").css("background", getBackgroundColorForMilestone(milestone.class));
        if (index > 0) {
          $("." + milestones[index - 1].class).removeClass("active");
        }
      }
    });
    if (totalPrice < milestones[0].threshold) {
      $(".progress-bar-wrapper--content").find(".progress-bar").css("background", getBackgroundColorForMilestone("default")); // Set to default color
    }
  }


  // Function to return background color based on milestone class
  function getBackgroundColorForMilestone(milestoneClass) {
    switch (milestoneClass) {
      case "milestone-one":
        // return "linear-gradient(90deg, #E1B9A9 0%, #DBB3A3 100%)";
        return "#309388";
      case "milestone-two":
        // return "linear-gradient(90deg, #EEE 0%, #F0F0F0 100%)";
        return "#309388";
      case "milestone-three":
        // return "linear-gradient(90deg, #F2EBD3 0%, #F5EED6 100%)";
        return "#309388";
      default:
        return "#309388";
    }
  }
  // *** END Update Progress Bar

  function updateTotalPrice() {
    // Apply discount based on totalPrice and update the UI
    let finalPrice = totalPrice;
    let isDiscountApplied = false;

    // Apply discount before updating the UI
    if (totalPrice >= 900) {
      finalPrice = applyDiscount(totalPrice); // Apply the discount
      isDiscountApplied = true;
    }

    // Update the UI with the final price (after discount, if applicable)
    $(".sticky-bundle-wrapper-content-total-price").text(
        dataCurrency + finalPrice.toFixed(2)
    );
    $(".sticky-bundle-wrapper-content-discount-price").text(
        dataCurrency + finalPrice.toFixed(2)
    );
    if (isDiscountApplied) {
      $(".sticky-bundle-wrapper-content-discount-price").css("display", "block");
      $(".sticky-apply-discount-wrapper").addClass("active");  
    } else {
      $(".sticky-bundle-wrapper-content-discount-price").css("display", "none");
      $(".sticky-apply-discount-wrapper").removeClass("active");  
    }
    $("#current-amount").text(finalPrice.toFixed(2));
  }
  
  // Function to apply the discount based on price
  function applyDiscount(price) {
    if (price >= 900 && price < 1300) {
        return price * 0.95; // 5% discount for prices between 1000 and 1499
    } else if (price >=1300 && price < 1800) {
        return price * 0.9; // 10% discount for prices between 1500 and 1999
    } else if (price >= 1800) {
        return price * 0.85; // 15% discount for prices 2000 or more
    }
    return price; // No discount if less than 1000
  }

  function updateUI() {
    let finalPrice = applyDiscount(totalPrice); // Apply discount based on the updated totalPrice

    $(".sticky-bundle-wrapper-content-price").text(dataCurrency + totalPrice.toFixed(2));
    $(".sticky-bundle-wrapper-content-discount-price").text(dataCurrency + totalPrice.toFixed(2));
    $(".sticky-bundle-wrapper-content-total-price").text(dataCurrency + finalPrice.toFixed(2));
    $("#current-amount").text(finalPrice.toFixed(2));


    console.log("Updated totalPrice:", totalPrice);
    updateTotalPrice();
  }
  
  // *** SATRT popup Remining Amount JS
  function updateRemainingAmount() {
    const nextMilestone = milestones.find(
      (milestone) => totalPrice < milestone.threshold
    );

    if (nextMilestone) {
      const remainingAmount = (nextMilestone.threshold - totalPrice).toFixed(2);
      console.log("remainingAmount ", remainingAmount);
      let discount = 0;
      if (nextMilestone.class === "milestone-one") discount = 5;
      else if (nextMilestone.class === "milestone-two") discount = 10;
      else if (nextMilestone.class === "milestone-three") discount = 15;
      $(".sticky-bundle-content").text(`Spend more ${remainingAmount} to get an additional ${discount}% off!`);
    } else {
      $(".sticky-bundle-content").text("You have unlocked the maximum discount!");
    }
  }
  // *** END popup Remining Amount JS

  // *** START Remove product item price function
  function removePrice(element) {
    let removeVariantId = element.closest(".sticky-bundle-product-content-wrapper").attr("data-variant-id");

    let removeArrayPrice =  bundleVariants.find(item => item.variantID === removeVariantId);
    
    if (removeArrayPrice) {
        totalPrice -= removeArrayPrice.productTotalPrice;
        totalPrice = Math.max(totalPrice, 0);

        removeArrayPrice.productTotalPrice = 0;

        $(".sticky-bundle-wrapper-content-price").text(dataCurrency + totalPrice.toFixed(2));
        $(".sticky-bundle-product-price").text(dataCurrency + totalPrice.toFixed(2));
        $(".sticky-bundle-wrapper-content-total-price").text(dataCurrency + totalPrice.toFixed(2));
        $("#current-amount").text(totalPrice.toFixed(2));
    }
  }
  // *** END Remove product item price function

  // ******* START chekout redirection Ajax - Updated to sync with cart in real-time, no batch add needed
  function ajaxCheckoutJS() {
    // No longer needed: items are added in real-time via individual add/minus events
    // Just redirect to checkout
    window.location.href = "/cart";
  }
  // ******* END chekout redirection Ajax

  // *** START Restore bundle from cart on page load for bi-directional sync
  function restoreBundleFromCart() {
    $.getJSON('/cart.js', function(cart) {
      let cartVariants = {};
      cart.items.forEach(function(item) {
        let vid = item.variant_id.toString();
        if (!cartVariants[vid]) {
          cartVariants[vid] = { quantity: 0 };
        }
        cartVariants[vid].quantity += item.quantity;
      });

      bundleVariants = [];
      totalPrice = 0;
      currentIndex = 0;

      Object.keys(cartVariants).forEach(function(vid) {
        let el = $('.ajax-add-to-cart[data-variantid="' + vid + '"]');
        if (el.length === 0) return; // Not a bundle product

        let closestWrapper = el.closest(".product-list-wrapper-with-content");
        let imageSrc = closestWrapper.find("img").attr("src");
        let productTitle = el.attr("data-product-title");
        let productPriceStr = el.attr("data-product-price");
        let numericPrice = parseFloat(productPriceStr.replace(/[^0-9.-]+/g, ""));
        let qty = cartVariants[vid].quantity;
        let productTotalPrice = numericPrice * qty;

        bundleVariants.push({
          variantID: vid,
          productTitle: productTitle,
          quantity: qty,
          productTotalPrice: productTotalPrice
        });

        totalPrice += productTotalPrice;

        // Add to sticky UI
        if (currentIndex < 3) {
          replaceDefaultItem(el);
        } else {
          addNewStickyItem(el, closestWrapper);
        }
        currentIndex++;

        // Add to popup
        updatePopupList(el, imageSrc, productPriceStr);

        // Set quantity in product selector
        let $quantityInput = closestWrapper.find(".select-quantity input");
        $quantityInput.val(qty).attr("value", qty).trigger("change");

        // Hide add button, show quantity
        el.css("display", "none");
        closestWrapper.find(".select-quantity").css("display", "flex");

        // Set quantity display in sticky and popup
        let $stickyItems = $(".sticky-bundle-product-content-wrapper[data-variant-id='" + vid + "'] .quantity-add-remove");
        let $popupItems = $(".popup-product-item[data-variant-id='" + vid + "'] .quantity-add-remove");
        $stickyItems.text(qty);
        $popupItems.text(qty);
      });

      // Update UI
      updateUI();
      updateProgressBar();
      updateRemainingAmount();
      suggestionText();

      // Enable/disable popup based on items
      if (currentIndex > 0) {
        $(".sticky-bundle-product-add-wrapper ul").find(".sticky-bundle-popup-wrapper .popup-open-wrapper").css({ "pointer-events": "inherit", opacity: "1" });
      } else {
        $(".sticky-bundle-product-add-wrapper ul").find(".sticky-bundle-popup-wrapper .popup-open-wrapper").css({ "pointer-events": "none", opacity: ".4" });
      }
    }).fail(function() {
      console.log("Failed to fetch cart for restore");
    });
  }
  // *** END Restore bundle from cart

  //*** START Ajax cart click event - Updated to add to cart in real-time
  $(document).on("click", ".ajax-add-to-cart", function () {
    const closestWrapper = $(this).closest(".product-list-wrapper-with-content");
    const imageSrc = closestWrapper.find("img").attr("src");
    const productPrice = $(this).attr("data-product-price");
    const productTitle = $(this).attr("data-product-title");
    const variantID = $(this).attr("data-variantid");
    addPrice($(this), productPrice);
    const variantDetails = {
      variantID: variantID,
      productTitle: productTitle,
      quantity: 1,
      productTotalPrice: parseFloat($(this).attr("data-product-price")) || 0,
    };
    bundleVariants.push(variantDetails);
    if (currentIndex < 3) {
      replaceDefaultItem($(this));
    } else {
      addNewStickyItem($(this), closestWrapper);
    }
    currentIndex++;
    updatePopupList($(this), imageSrc, productPrice);
    // updatePopupProductTitleList($(this), productTitle);
    updateProgressBar();
    updateRemainingAmount();
    suggestionText();
    
    // **Quantity add logic**
    const $quantityInput = closestWrapper.find(".select-quantity input");
    let quantity = parseInt($quantityInput.val()) || 0;
    var newQuantity = quantity + 1;
    // **Update both value & attr("value")**
    $quantityInput.val(newQuantity).attr("value", newQuantity).trigger("change");
    
    var $stickyItem = $(".sticky-bundle-product-content-wrapper[data-variant-id='" + variantID + "'], " +
              ".popup-product-item[data-variant-id='" + variantID + "']");
    if ($stickyItem.length) {
        $stickyItem.find(".quantity-add-remove").text(newQuantity);
    }

    // **Hide 'ajax-add-to-cart' button**
    $(this).closest(".product-list-wrapper-with-content").find(".ajax-add-to-cart").css("display","none");
    closestWrapper.find(".select-quantity").css("display","flex");

    $(".minus-quantity").css("pointer-events","auto");

    // **Sync with cart: add 1 to this variant**
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: parseInt(variantID, 10),
        quantity: 1
      })
    }).then(response => {
      if (!response.ok) throw new Error("Failed to add to cart");
    }).catch(error => {
      console.error("Error adding to cart:", error);
      // Optionally revert local state on failure
    });
  });
  //*** END Ajax cart click event

  // *** START Event listener for removing a product item from the sticky bundle - Updated to remove from cart
  $(document).on("click", ".sticky-item-close-icon", function () {
    // var removeEventButton = $(this).closest(".sticky-bundle-product-content-wrapper").attr("data-variant-id");
    // $(".ajax-add-to-cart[data-variantid='" + removeEventButton + "']").css({"pointer-events":"auto","background":"#87d2d8"});
    removePrice($(this));

    var removeItemVariantId = $(this).closest(".sticky-bundle-product-content-wrapper").attr("data-variant-id");
    const variantIndex = bundleVariants.findIndex((v) => v.variantID === removeItemVariantId);
    let existingVariant = bundleVariants[variantIndex];
    if (existingVariant) {
      // **Sync with cart: remove entire variant (set quantity to 0)**
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: parseInt(removeItemVariantId, 10),
          quantity: 0
        })
      }).then(response => {
        if (!response.ok) throw new Error("Failed to remove from cart");
      }).catch(error => {
        console.error("Error removing from cart:", error);
        // Optionally revert local state on failure
      });
    }

    if (variantIndex !== -1) {
      bundleVariants.splice(variantIndex, 1);
    }
    if (currentIndex <= 3) {
      // $(this).closest("li").removeClass("sticky-product-item");
      var stickyBundleDefault = $(this).closest("li").find(".sticky-bundle-product-content-wrapper");
      stickyBundleDefault.addClass("sticky-bundle-default-item");
      stickyBundleDefault.attr("data-price", "");
      stickyBundleDefault.attr("data-title", "");
      stickyBundleDefault.attr("data-variant-id", "");
      var defaultImage = $(this).closest(".sticky-bundle-product-add-wrapper").attr("data-default-image");
      var defaultPrice = $(this).closest(".sticky-bundle-product-add-wrapper").attr("data-default-price");
      stickyBundleDefault.find(".sticky-bundle-product-content-image img").attr("src", defaultImage);
      stickyBundleDefault.find(".sticky-item-close-icon").css("display", "none");
      stickyBundleDefault.find(".quantity-add-remove").css("display", "none");
      stickyBundleDefault.find(".product-item-price").text(defaultPrice);
    } else {
      $(this).closest("li").remove();
    }
    $(".popup-product-item[data-variant-id='" + removeItemVariantId + "']").first().remove();
    $(".popup-product-title-item[data-variant-id='" + removeItemVariantId + "']").first().remove();
    if (currentIndex > 0) {
      currentIndex--;
    }
    updateProgressBar();
    updateRemainingAmount();
    if (currentIndex === 0) {
      $(this).closest("ul").find(".sticky-bundle-popup-wrapper .popup-open-wrapper").css({ "pointer-events": "none", opacity: ".4" });
    }
    suggestionText();
    
    var $variant = $(".ajax-add-to-cart[data-variantid='" + removeItemVariantId + "']");
    $variant.css("display", "block");
    $variant.closest(".product-list-wrapper-with-content").find(".select-quantity").css("display", "none");
    $variant.closest(".product-list-wrapper-with-content").find(".select-quantity input").val(0).attr("value", 0);
    updateUI();
  });
  // *** END Event listener for removing a product item from the sticky bundle

  // *** START popup open js
  $(document).on("click", ".popup-open-wrapper", function () {
    $(".sticky-bundle-popup-wrapper-content").addClass("active");
    $(".sticky-header-enable .header").css("z-index", "-1");
    // $(".progress-bar-sticky-wrapper.sticky .progress-container").css("z-index","0");
    $("body").css("overflow", "hidden");
  });
  // *** END popup open js

  // *** START popup close js
  $(document).on("click", ".sticky-bundle-close-popup,.sticky-bundle-overlay", function () {
      $(".sticky-bundle-popup-wrapper-content").removeClass("active");
      $(".sticky-header-enable .header").css("z-index", "5");
      // $(".progress-bar-sticky-wrapper.sticky .progress-container").css("z-index","3");
      $("body").css("overflow", "auto");
    }
  );
  // *** END popup close js

  //********** START Bundle popup close icon event
  $(document).on("click", ".bundle-popup-close-icon", function () {
    var popupRemovedItem = $(this).closest(".popup-product-item").attr("data-variant-id");
    $(".sticky-bundle-product-add").find(".sticky-bundle-product-content-wrapper[data-variant-id='" + popupRemovedItem + "']").first();
    var stickyMatchedItem = $(".sticky-bundle-product-add").find(".sticky-bundle-product-content-wrapper[data-variant-id='" + popupRemovedItem + "']").first();
    stickyMatchedItem.find(".sticky-item-close-icon").trigger("click");
  });
  //********** END Bundle popup close icon event

  //************* START ajax checkout button event - Updated to redirect without adding (real-time sync handles adds)
  $(document).on("click", ".ajax-checkout-button", function () {
    // processBundleVariants(bundleVariants, $(this));
    $(this).find(".sticky-bundle-text").addClass("active");
    $(this).find(".loading-button").addClass("active");
    let $this = $(this)
    setTimeout(function(){
      $this.find(".sticky-bundle-text").removeClass("active");
      $this.find(".loading-button").removeClass("active");
      ajaxCheckoutJS(); // Now just redirects
    }, 1500)
    // Hide the UpCart drawer before adding items
    $("#CartPopup, .upcart-backdrop").attr("style", "display: none !important;");
  });
  //************* END ajax checkout button event

  //************* START Suggestion text
  function suggestionText() {
    let suggestion = "Suggestion: Add 2 Bijou Haven in your cart";
    const allTitles = bundleVariants.map(item => item.productTitle.toLowerCase().trim().replace(/\s+/g, " "));
    // Define keyword pairs and corresponding suggestions
    const keywordPairs = [
        { keywords: ["mainstay", "swing arm"], suggestion: "Suggestion: Add 1 Sway swing and 1 Skate swing" },
        { keywords: ["mainstay", "rope bridge"], suggestion: "Suggestion: Add a second Mainstay" },
        { keywords: ["rope bridge"], suggestion: "Suggestion: Add 1 Bijou Pocket" },
        { keywords: ["haven"], suggestion: "Suggestion: Add 1 Hover swing" },
        { keywords: ["mainstay"], suggestion: "Suggestion: Add 1 Next Level" }
    ];
    
    // Check for matching keyword pairs in allTitles
    for (const pair of keywordPairs) {
      const { keywords, suggestion: pairSuggestion } = pair;
      const match = keywords.every(keyword => allTitles.some(title => title.includes(keyword.toLowerCase())));
      if (match) {
          suggestion = pairSuggestion;
          // $("#suggestion").text(suggestion);
          break;
      }
     }
    $("#suggestion").text(suggestion);
    return suggestion;
  }

  //************* END Suggestion text

  function chooseAjaxCheckoutJS(chooseVariantId) {
    const payload = {
      items: [{
        id: parseInt(chooseVariantId, 10), // Use the passed variant ID
        quantity: 1, // Default to 1 if quantity is not provided
      }],
    };

    // Send the POST request
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to add products to the cart");
        }
        return response.json();
      })
      .then((data) => {
        console.log("Products added to the cart:", data);
      })
      .catch((error) => {
        console.error("Error adding products to the cart:", error);
      });
  }
  //************* START Choose section add to cart js
  $(document).on("click",".choose-ajax-add-to-cart",function(){
    var chooseVariantId = $(this).attr("data-variantid");
    chooseAjaxCheckoutJS(chooseVariantId);
  });
  //************* END Choose section add to cart js
  
  //************* START Quantity selector plus icon click event - Updated to sync with cart
  $(document).on("click", ".plus-quantity", function () {
    var $input = $(this).siblings(".select-quantity input");
    var value = parseInt($input.val()) || 0;
    var newQuantity = value + 1;
    let $productPrice = $(this).attr("data-product-price");
    addPrice($(this), $productPrice);
    
    $input.val(newQuantity).attr("value", newQuantity).trigger("change");

    let variantID = $(this).closest(".product-list-wrapper-with-content").find(".ajax-add-to-cart").attr("data-variantid");
    let productTitle = $(this).closest(".product-list-wrapper-with-content").find(".ajax-add-to-cart").attr("data-product-title");

    let existingVariant = bundleVariants.find(item => item.variantID === variantID && item.productTitle === productTitle);
    var $stickyItem = $(".sticky-bundle-product-content-wrapper[data-variant-id='" + variantID + "'], " +
              ".popup-product-item[data-variant-id='" + variantID + "']");
    if ($stickyItem.length) {
        $stickyItem.find(".quantity-add-remove").text(newQuantity);
    }
    if (existingVariant) {
        existingVariant.quantity += 1;
        existingVariant.productTotalPrice += parseFloat($(this).attr("data-product-price")) || 0;
    }
    updateProgressBar();
    updateRemainingAmount();

    // **Sync with cart: add 1 more**
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: parseInt(variantID, 10),
        quantity: 1
      })
    }).then(response => {
      if (!response.ok) throw new Error("Failed to add to cart");
    }).catch(error => {
      console.error("Error adding to cart:", error);
      // Optionally revert local state on failure
    });
  });
  //************* END Quantity selector plus icon click event
  
  //************* START Quantity selector minus icon click event - Updated to sync with cart
  $(document).on("click", ".minus-quantity", function () {
    var $input = $(this).siblings(".select-quantity input");
    var value = parseInt($input.val()) || 0;
    var newQuantity = value - 1;
  
    // **Update input value**
    $input.val(newQuantity).attr("value", newQuantity).trigger("change");

    const variantID = $(this).closest(".product-list-wrapper-with-content").find(".ajax-add-to-cart").attr("data-variantid");
    const productTitle = $(this).closest(".product-list-wrapper-with-content").find(".ajax-add-to-cart").attr("data-product-title");
  
    let existingVariant = bundleVariants.find(item => item.variantID === variantID && item.productTitle === productTitle);
  
    var $stickyItem = $(".sticky-bundle-product-content-wrapper[data-variant-id='" + variantID + "'], " +
        ".popup-product-item[data-variant-id='" + variantID + "']");

    if ($stickyItem.length) {
        $stickyItem.find(".quantity-add-remove").text(newQuantity);
    }

    let unitPrice = parseFloat($(this).attr("data-product-price").replace(/[^0-9.-]+/g, "")) || 0;
    if (existingVariant) {
        existingVariant.quantity -= 1;
        existingVariant.productTotalPrice -= unitPrice;

        totalPrice -= unitPrice;
        totalPrice = Math.max(totalPrice, 0); // **Ensure totalPrice doesn't go negative**

        // **Update UI elements**
        $(".sticky-bundle-product-price").text(dataCurrency + totalPrice.toFixed(2))
        updateUI();

        // **Sync with cart**
        let cartQuantity = newQuantity > 0 ? newQuantity : 0;
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: parseInt(variantID, 10),
            quantity: cartQuantity
          })
        }).then(response => {
          if (!response.ok) throw new Error("Failed to update cart");
        }).catch(error => {
          console.error("Error updating cart:", error);
          // Optionally revert local state on failure
        });

        // **Remove item if quantity reaches 0**
        if (existingVariant.quantity <= 0) {
            bundleVariants = bundleVariants.filter(item => !(item.variantID === variantID && item.productTitle === productTitle));
            if ($stickyItem.length) {
                $stickyItem.find(".sticky-item-close-icon").trigger("click");
            }

            $input.val(0).attr("value", 0);
            var $this = $(this);
            setTimeout(function () {
                $this.closest(".select-quantity").hide();
            }, 100);

            $this.closest(".product-list-wrapper-with-content").find(".ajax-add-to-cart").show();
            $(this).css("pointer-events", "none");
        }
    }
    
    // **Update progress bar**
    updateProgressBar();
    updateRemainingAmount();
  });
  
  //************* END Quantity selector minus icon click event
  
  $(window).on("scroll", function () {
    var $progressBar = $(".progress-bar-sticky-wrapper");

    if ($progressBar.length) {
      var offsetTop = $progressBar.offset().top;
      var scrollTop = $(window).scrollTop();

      if (scrollTop >= offsetTop) {
          $progressBar.addClass("sticky");
      } else {
          $progressBar.removeClass("sticky");
      }
    }
  });

  $(document).on("click", ".down-arrow-btn", function () {
    var $bundleList = $(".sticky-bundle-product-add ul");
    
    if ($bundleList.is(":visible")) {
        $bundleList.slideUp();
        $(this).removeClass("active");
    } else {
        $bundleList.css("display", "flex").hide().slideDown();
        $(this).addClass("active");
    }
  });



  $(document).on("click", ".product-info-icon", function () {
    var handle = $(this).attr("data-handle"); // Get product handle from the clicked product

    if (!handle) {
        console.log("Product handle not found");
        return;
    }

    // Fetch product details dynamically
    $.getJSON('/products/' + handle + '.js', function (product) {
        if (product && product.description) {
            $(".bundle-builder-info-popup").addClass("active");
            $("body").css("overflow","hidden");
            $(".product-description").html(product.description); // Update the description dynamically
        } else {
            $(".product-description").html("<p>Description not available</p>");
        }
    });
  });
  $(document).on("click", ".info-popup-close, .overflow-layer", function () {
    $(".bundle-builder-info-popup").removeClass("active");
    $("body").css("overflow","auto");
    $(".product-description").html(""); // Clear the description
  });

  // Restore from cart on load
  restoreBundleFromCart();

});




// Function to check if the price is zero
function isPriceZero(priceText) {
  const cleanedPrice = priceText.replace(/[^\d.-]/g, ''); // Remove non-numeric chars except dot and minus
  const priceValue = parseFloat(cleanedPrice);
  return !isNaN(priceValue) && priceValue === 0;
}

// Function to toggle the button visibility
function toggleButtonVisibility() {
  const priceElement = document.querySelector('.sticky-bundle-wrapper-content-price');
  const buttonElement = document.querySelector('.mobile-arrows-btn');
  
  if (priceElement && buttonElement) {
    const priceText = priceElement.textContent.trim();
    const isZero = isPriceZero(priceText);
    buttonElement.style.display = isZero ? 'none' : 'block';
  }
}

// Initial check
document.addEventListener('DOMContentLoaded', toggleButtonVisibility);

// Set up MutationObserver to watch for changes in the price element
const priceElement = document.querySelector('.sticky-bundle-wrapper-content-price');
if (priceElement) {
  const observer = new MutationObserver(toggleButtonVisibility);
  observer.observe(priceElement, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: false
  });
} else {
  // If price element not found initially, check periodically until it appears
  const interval = setInterval(() => {
    const element = document.querySelector('.sticky-bundle-wrapper-content-price');
    if (element) {
      clearInterval(interval);
      toggleButtonVisibility(); // Initial check
      const observer = new MutationObserver(toggleButtonVisibility);
      observer.observe(element, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: false
      });
    }
  }, 100); // Check every 100ms
}


/**** my code for bundle builder *****/
